<template>
  <ValidationProvider
    :vid="vid"
    :name="$attrs.name || $attrs.label"
    :rules="rules"
    v-slot="{ errors, valid }"
  >
    <p class="is-size-7 has-text-grey-icon">
      {{ prompt.name }}
      <b-tooltip
        class="ml-2"
        v-if="prompt.tooltip"
        :label="prompt.tooltip"
        type="is-tooltip"
        position="is-right"
      >
        <b-icon
          class="file-icon"
          icon-pack="fa"
          icon="info-circle"
          type="is-info"
        ></b-icon>
      </b-tooltip>
    </p>
    <b-field
      :type="{ 'is-danger': errors[0], 'is-success': valid }"
      :message="errors"
    >
      <b-upload v-model="file" drag-drop expanded :disabled="disabled">
        <section class="section">
          <div class="content has-text-centered">
            <p>
              <b-icon icon="upload" size="is-large"></b-icon>
            </p>
            <p>
              <strong>{{ prompt.label }}</strong>
            </p>
            <p>
              <i>{{ $t("mp:upload.title") }}</i>
            </p>
          </div>
        </section>
      </b-upload>
    </b-field>

    <div v-if="file" class="tags">
      <span class="tag is-primary">
        {{ file.name }}
        <button
          class="delete is-small"
          type="button"
          @click="file = null"
        ></button>
      </span>
    </div>

    <p>
      <strong>{{ $t("mp:upload.help.title") }} </strong>{{ prompt.help }}
    </p>

    <slot></slot>
  </ValidationProvider>
</template>

<script>
export default {
  props: {
    vid: {
      type: String,
    },
    rules: {
      type: [Object, String],
      default: "",
    },
    value: {
      type: null,
    },
    prompt: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
    },
  },
  data: () => ({
    file: null,
  }),
  watch: {
    // Handles internal model changes.
    async file(newVal) {
      this.$emit("documentUploadStart");
      await this.$store.dispatch("application/uploadFile", {
        file: this.file,
        promptId: this.prompt.id,
        promptIdentifier: this.prompt.identifier,
        documentName: this.prompt.name,
      });
      this.$emit("documentUploadFinish");
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    },
  },
  created() {
    if (this.value) {
      this.file = this.value;
    }
  },
};
</script>
